// Public share link for virtuals (/v/:token) — approved virtuals only; the
// API never returns anything a rep hasn't approved.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Logo } from "@/components/Logo";

interface PublicVirtual { id: string; productName: string; colour: string | null; decoration: string; imageUrl: string }

export function PublicVirtualsPage() {
  const { token } = useParams<{ token: string }>();
  const [data, setData] = useState<{ title: string | null; virtuals: PublicVirtual[] } | null>(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    fetch(`/public/virtuals/${token}`, { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setData)
      .catch(() => setMissing(true));
  }, [token]);
  return (
    <div className="min-h-screen bg-canvas">
      <header className="border-b border-rule bg-white">
        <div className="mx-auto flex h-[68px] max-w-5xl items-center px-4"><Logo /></div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">
        <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-muted">Virtuals for approval</p>
        <h1 className="mb-2 mt-2 text-[32px] font-semibold leading-[1.15] tracking-[-1px] text-ink">{data?.title ?? "Your logo, on the products"}</h1>
        <p className="mb-8 max-w-2xl text-sm text-muted">These are virtuals — a close preview of your decoration, true to the maker's imprint size. A final proof follows before anything is produced.</p>
        {missing && <p className="rounded-lg border border-rule bg-white px-5 py-8 text-center text-sm text-muted">This link isn't available any more. Ask your rep for a new one.</p>}
        <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {(data?.virtuals ?? []).map((v) => (
            <li key={v.id} className="overflow-hidden rounded-lg border border-rule bg-white">
              <div className="aspect-[4/3] bg-canvas"><img src={v.imageUrl} alt={`${v.productName} with your logo`} className="h-full w-full object-contain" /></div>
              <div className="p-3">
                <p className="text-sm font-semibold text-ink">{v.productName}</p>
                <p className="text-xs text-muted">{[v.colour, v.decoration].filter(Boolean).join(" · ")}</p>
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
